import React from "react";
import { Link, NavLink } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Workbook", id: "workbook", end: true, desktopOnly: true },
  { to: "/pricing", label: "Pricing", id: "pricing" },
  { to: "/faq", label: "FAQ", id: "faq" },
  { to: "/blog", label: "Journal", id: "journal" },
  { to: "/about", label: "About", id: "about" },
];

export default function SiteHeader() {
  return (
    <header
      className="relative z-20 border-b border-obsidian-600/60 bg-obsidian-900/70 backdrop-blur-md"
      data-testid="site-header"
    >
      <nav
        aria-label="Main"
        className="max-w-6xl mx-auto px-4 sm:px-8 md:px-16 h-14 flex items-center justify-between gap-4"
      >
        <Link
          to="/"
          data-testid="site-header-logo"
          className="font-serif text-lg sm:text-xl tracking-[0.14em] sm:tracking-[0.18em] text-bone-100 hover:text-terracotta transition-colors"
        >
          UMBRA
        </Link>
        <ul className="flex items-center gap-0 sm:gap-5">
          {LINKS.map((l) => (
            <li key={l.id} className={l.desktopOnly ? "hidden sm:block" : ""}>
              <NavLink
                to={l.to}
                end={l.end}
                data-testid={`site-nav-${l.id}`}
                className={({ isActive }) =>
                  `inline-flex items-center min-h-[44px] px-1.5 sm:px-2 font-serif text-[0.9rem] sm:text-base whitespace-nowrap transition-colors ${
                    isActive ? "text-terracotta" : "text-bone-300 hover:text-bone-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
